export default __webpack_public_path__ + "static/media/CNo.68-4.cf6874a1.jpg";